import { Button } from "../components/ui/button";
import Logo from "../components/Logo";

export default function Login() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const startLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img
          alt=""
          src="https://images.unsplash.com/photo-1705909773420-8d7af2a343f9?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-black/30 to-transparent" />
        <div className="absolute top-10 left-10">
          <p className="text-white/90 font-heading text-3xl tracking-wide">Leadera<span className="text-[#D4AF37]">.</span></p>
          <p className="text-white/60 text-[10px] uppercase tracking-[0.3em] mt-1">Corp</p>
        </div>
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="overline text-white/70">PROPOSTAS · CONTRATOS · TREINAMENTOS</p>
          <h2 className="font-heading text-4xl leading-tight mt-3">
            Autoridade B2B em cada<br />documento entregue.
          </h2>
          <p className="mt-3 text-white/80 max-w-md text-sm">
            Gere orçamentos elegantes, colete assinaturas digitais e feche negócios mais rápido — com trilha de auditoria e IA a favor do seu time.
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md">
          <div className="mb-10">
            <Logo size="xl" />
          </div>
          <p className="overline">Acesso Restrito</p>
          <h1 className="font-heading text-4xl sm:text-5xl mt-3">Bem-vindo de volta.</h1>
          <p className="mt-3 text-sm text-muted-foreground max-w-sm">
            Entre com sua conta Google corporativa para acessar o painel Leadera.
          </p>
          <Button
            data-testid="google-login-btn"
            onClick={startLogin}
            className="mt-8 w-full h-12 bg-[#C07C88] hover:bg-[#A86571] text-white rounded-md font-medium text-sm tracking-wide"
          >
            Continuar com Google
          </Button>
          <p className="mt-6 text-xs text-muted-foreground">
            Ao continuar, você concorda com os termos de uso e política de privacidade da Leadera Corp.
          </p>
        </div>
      </div>
    </div>
  );
}
